// extracted by mini-css-extract-plugin
export default {"factItemContainer":"FactItem_factItemContainer__n8xV0","factTitle":"FactItem_factTitle__4XNBd","factContent":"FactItem_factContent__je8NK"};